import React, { useState } from 'react';
import { Sparkles, Link2, Eye, CheckCircle, FileText, ArrowRight, Loader2, Copy, ExternalLink, LayoutList, BookOpen, Lightbulb, MessageCircle, Pen, Search, Image as ImageIcon, RefreshCw } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PLATFORMS = [
  { id: 'instagram', label: 'Instagram', color: '#E1306C', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
  )},
  { id: 'facebook', label: 'Facebook', color: '#4267B2', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.875v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  )},
  { id: 'linkedin', label: 'LinkedIn', color: '#0A66C2', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  )},
  { id: 'twitter', label: 'Twitter/X', color: '#1DA1F2', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
  )},
  { id: 'tiktok', label: 'TikTok', color: '#69C9D0', icon: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
  )},
  { id: 'original', label: 'Original', color: '#d9fb06', icon: <FileText size={16} /> },
];

const TEMPLATES = [
  {
    id: 'deep_analysis',
    name: 'Analisis Mendalam',
    desc: 'Artikel panjang dengan argumen berlapis, data, dan perspektif tajam',
    icon: <Search size={18} />,
    color: '#818cf8',
    badge: 'Populer',
  },
  {
    id: 'listicle',
    name: 'Listicle (Daftar)',
    desc: '5-10 poin bernomor yang mudah di-scan, cocok untuk social sharing',
    icon: <LayoutList size={18} />,
    color: '#38bdf8',
    badge: null,
  },
  {
    id: 'tips_practical',
    name: 'Tips Praktis',
    desc: 'Langkah-langkah actionable yang bisa langsung dipraktekkan pembaca',
    icon: <Lightbulb size={18} />,
    color: '#fbbf24',
    badge: null,
  },
  {
    id: 'storytelling',
    name: 'Storytelling',
    desc: 'Narasi yang memikat dengan karakter, konflik, dan pelajaran tersembunyi',
    icon: <BookOpen size={18} />,
    color: '#f472b6',
    badge: null,
  },
  {
    id: 'opinion_provocative',
    name: 'Opini Provokatif',
    desc: 'Pernyataan kontroversial yang menantang asumsi umum, tajam & berani',
    icon: <Pen size={18} />,
    color: '#fb923c',
    badge: 'Viral',
  },
  {
    id: 'qa_interview',
    name: 'Tanya-Jawab',
    desc: 'Format Q&A progresif dari basic ke advanced, mudah dipahami',
    icon: <MessageCircle size={18} />,
    color: '#4ade80',
    badge: null,
  },
  {
    id: 'case_study',
    name: 'Studi Kasus',
    desc: 'Analisis mendalam satu kasus spesifik: tokoh, perusahaan, atau fenomena',
    icon: <Eye size={18} />,
    color: '#a78bfa',
    badge: null,
  },
];

const SocialArticleCreator = ({ onArticleCreated, blogMsg, setBlogMsg }) => {
  const [step, setStep] = useState(1); // 1: input, 2: generating, 3: preview+images, 4: done
  const [platform, setPlatform] = useState('instagram');
  const [template, setTemplate] = useState('deep_analysis');
  const [postText, setPostText] = useState('');
  const [sourceUrl, setSourceUrl] = useState('');
  const [autoPublish, setAutoPublish] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [generatedArticle, setGeneratedArticle] = useState(null);
  const [genProgress, setGenProgress] = useState(0);
  // Image selection state
  const [imageOptions, setImageOptions] = useState([]); // [{id, url}]
  const [selectedImageIdx, setSelectedImageIdx] = useState(null);
  const [generatingImages, setGeneratingImages] = useState(false);
  const [imageProgress, setImageProgress] = useState(0);

  const selectedPlatform = PLATFORMS.find(p => p.id === platform);
  const selectedTemplate = TEMPLATES.find(t => t.id === template);

  const pollJobStatus = async (jobId) => {
    const maxAttempts = 60;
    for (let i = 0; i < maxAttempts; i++) {
      setGenProgress(Math.min(95, Math.round((i / 30) * 100)));
      await new Promise(r => setTimeout(r, 2000));
      try {
        const res = await axios.get(`${BACKEND_URL}/api/blog/admin/generate-job/${jobId}`);
        if (res.data.status === 'completed') {
          return { success: true, article: res.data.article };
        } else if (res.data.status === 'failed') {
          return { success: false, error: res.data.error || 'Generation failed' };
        }
      } catch (err) {
        if (i > 10) return { success: false, error: 'Koneksi terputus saat menunggu hasil' };
      }
    }
    return { success: false, error: 'Timeout: artikel terlalu lama di-generate' };
  };

  const pollImageJob = async (jobId) => {
    const maxAttempts = 90; // images take longer (~30s each x 3)
    for (let i = 0; i < maxAttempts; i++) {
      setImageProgress(Math.min(95, Math.round((i / 60) * 100)));
      await new Promise(r => setTimeout(r, 2000));
      try {
        const res = await axios.get(`${BACKEND_URL}/api/blog/admin/image-job/${jobId}`);
        if (res.data.status === 'images_ready') {
          return { success: true, image_urls: res.data.image_urls, image_ids: res.data.image_ids };
        } else if (res.data.status === 'failed') {
          return { success: false, error: res.data.error || 'Image generation failed' };
        }
      } catch (err) {
        if (i > 15) return { success: false, error: 'Koneksi terputus' };
      }
    }
    return { success: false, error: 'Timeout: gambar terlalu lama di-generate' };
  };

  const startImageGeneration = async (article) => {
    setGeneratingImages(true);
    setImageProgress(0);
    setImageOptions([]);
    setSelectedImageIdx(null);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/blog/admin/generate-article-images`, {
        article_id: article.id,
        title: article.title,
        excerpt: article.excerpt,
        tags: article.tags,
      });
      const jobId = res.data.job_id;
      const result = await pollImageJob(jobId);
      if (result.success && result.image_urls?.length > 0) {
        setImageOptions(result.image_urls.map((url, i) => ({
          id: result.image_ids[i],
          url: url.startsWith('/') ? `${BACKEND_URL}${url}` : url,
        })));
      } else {
        setBlogMsg('Gambar gagal di-generate: ' + (result.error || 'Unknown error'));
      }
    } catch (err) {
      setBlogMsg('Gagal generate gambar: ' + (err.response?.data?.detail || err.message));
    } finally {
      setGeneratingImages(false);
    }
  };

  const handleGenerate = async () => {
    if (!postText.trim() || postText.trim().length < 20) {
      setBlogMsg('Teks postingan terlalu pendek (minimal 20 karakter)');
      return;
    }
    setGenerating(true);
    setStep(2);
    setGenProgress(0);
    setBlogMsg('');
    try {
      const startRes = await axios.post(`${BACKEND_URL}/api/blog/admin/generate-from-social`, {
        post_text: postText, platform, template,
        source_url: sourceUrl, auto_publish: autoPublish,
      });
      const jobId = startRes.data.job_id;
      if (!jobId) throw new Error('No job ID returned');

      const result = await pollJobStatus(jobId);
      if (result.success) {
        setGeneratedArticle(result.article);
        setStep(3);
        setBlogMsg(`Artikel "${result.article?.title}" berhasil! Pilih gambar ilustrasi di bawah.`);
        if (onArticleCreated) onArticleCreated();
        // Auto-start image generation
        startImageGeneration(result.article);
      } else {
        setBlogMsg('Gagal generate: ' + result.error);
        setStep(1);
      }
    } catch (err) {
      setBlogMsg('Gagal generate: ' + (err.response?.data?.detail || err.message));
      setStep(1);
    } finally {
      setGenerating(false);
    }
  };

  const handleSelectImage = async (idx) => {
    setSelectedImageIdx(idx);
    const img = imageOptions[idx];
    if (!img || !generatedArticle) return;
    try {
      await axios.put(`${BACKEND_URL}/api/blog/admin/article/${generatedArticle.id}/featured-image`, {
        image_url: img.url.replace(BACKEND_URL, ''),
      });
      setGeneratedArticle(prev => ({ ...prev, featured_image: img.url }));
      setBlogMsg('Gambar ilustrasi berhasil diperbarui!');
    } catch (err) {
      setBlogMsg('Gagal update gambar: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleRegenerateImages = () => {
    if (generatedArticle) {
      startImageGeneration(generatedArticle);
    }
  };

  const handleReset = () => {
    setStep(1);
    setPostText('');
    setSourceUrl('');
    setGeneratedArticle(null);
    setImageOptions([]);
    setSelectedImageIdx(null);
    setBlogMsg('');
  };

  const handlePublishDraft = async () => {
    if (!generatedArticle) return;
    try {
      await axios.put(`${BACKEND_URL}/api/blog/admin/articles/${generatedArticle.id}`, { status: 'published' });
      setGeneratedArticle({ ...generatedArticle, status: 'published' });
      setBlogMsg(`"${generatedArticle.title}" berhasil dipublish!`);
      if (onArticleCreated) onArticleCreated();
    } catch (err) {
      setBlogMsg('Gagal publish: ' + (err.response?.data?.detail || err.message));
    }
  };

  const cardStyle = {
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '1rem',
    padding: '1.5rem',
    marginBottom: '1.5rem',
  };

  return (
    <div style={cardStyle} data-testid="social-article-creator">
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
        <div style={{
          width: '36px', height: '36px', borderRadius: '10px',
          background: 'linear-gradient(135deg, rgba(225,48,108,0.2), rgba(66,103,178,0.2))',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Sparkles size={18} color="#d9fb06" />
        </div>
        <div>
          <h3 style={{ color: '#EDEDED', fontSize: '1rem', fontWeight: 600, margin: 0 }} data-testid="social-creator-title">
            Buat Artikel dari Media Sosial
          </h3>
          <p style={{ color: '#71717A', fontSize: '0.75rem', margin: 0 }}>
            Paste caption atau teks postingan, AI akan membuat artikel blog
          </p>
        </div>

        {/* Step indicator */}
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          {[1, 2, 3].map(s => (
            <div key={s} style={{
              width: '24px', height: '24px', borderRadius: '50%', fontSize: '0.7rem', fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: step >= s ? (s === 3 ? 'rgba(74,222,128,0.2)' : 'rgba(217,251,6,0.15)') : 'rgba(255,255,255,0.05)',
              color: step >= s ? (s === 3 ? '#4ade80' : '#d9fb06') : '#71717A',
              border: step === s ? '1.5px solid' : '1px solid transparent',
              borderColor: step === s ? (s === 3 ? '#4ade80' : '#d9fb06') : 'transparent',
            }}>
              {step > s ? <CheckCircle size={12} /> : s}
            </div>
          ))}
        </div>
      </div>

      {/* Step 1: Input */}
      {step === 1 && (
        <div data-testid="social-creator-step1">
          {/* Platform selector */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ fontSize: '0.8rem', color: '#A1A1AA', marginBottom: '0.5rem', display: 'block' }}>
              Platform Sumber
            </label>
            <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
              {PLATFORMS.map(p => (
                <button
                  key={p.id}
                  onClick={() => setPlatform(p.id)}
                  data-testid={`platform-btn-${p.id}`}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.375rem',
                    padding: '0.5rem 0.875rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer',
                    fontSize: '0.8rem', fontWeight: 500,
                    background: platform === p.id ? `${p.color}20` : 'rgba(255,255,255,0.04)',
                    color: platform === p.id ? p.color : '#A1A1AA',
                    outline: platform === p.id ? `1.5px solid ${p.color}40` : 'none',
                    transition: 'all 0.15s ease',
                  }}
                >
                  {p.icon}
                  {p.label}
                </button>
              ))}
            </div>
          </div>

          {/* Template selector */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ fontSize: '0.8rem', color: '#A1A1AA', marginBottom: '0.5rem', display: 'block' }}>
              Template Artikel
            </label>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
              gap: '0.5rem',
            }}>
              {TEMPLATES.map(t => (
                <button
                  key={t.id}
                  onClick={() => setTemplate(t.id)}
                  data-testid={`template-btn-${t.id}`}
                  style={{
                    display: 'flex', alignItems: 'flex-start', gap: '0.625rem',
                    padding: '0.75rem', borderRadius: '0.625rem', border: 'none', cursor: 'pointer',
                    textAlign: 'left', position: 'relative',
                    background: template === t.id ? `${t.color}12` : 'rgba(255,255,255,0.03)',
                    outline: template === t.id ? `1.5px solid ${t.color}50` : '1px solid rgba(255,255,255,0.06)',
                    transition: 'all 0.15s ease',
                  }}
                >
                  <div style={{
                    width: '32px', height: '32px', borderRadius: '8px', flexShrink: 0,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: template === t.id ? `${t.color}20` : 'rgba(255,255,255,0.05)',
                    color: template === t.id ? t.color : '#71717A',
                  }}>
                    {t.icon}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
                      <span style={{
                        fontSize: '0.8rem', fontWeight: 600,
                        color: template === t.id ? t.color : '#EDEDED',
                      }}>
                        {t.name}
                      </span>
                      {t.badge && (
                        <span style={{
                          fontSize: '0.6rem', padding: '1px 5px', borderRadius: '6px',
                          background: `${t.color}20`, color: t.color, fontWeight: 600,
                        }}>
                          {t.badge}
                        </span>
                      )}
                    </div>
                    <p style={{
                      fontSize: '0.68rem', color: '#71717A', margin: '2px 0 0',
                      lineHeight: 1.3, overflow: 'hidden',
                      display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                    }}>
                      {t.desc}
                    </p>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Post text */}
          <div style={{ marginBottom: '0.75rem' }}>
            <label style={{ fontSize: '0.8rem', color: '#A1A1AA', marginBottom: '0.375rem', display: 'block' }}>
              Teks / Caption Postingan <span style={{ color: '#f87171' }}>*</span>
            </label>
            <textarea
              value={postText}
              onChange={e => setPostText(e.target.value)}
              placeholder={`Paste caption ${selectedPlatform?.label || 'media sosial'} di sini...\n\nContoh: "Kenapa orang bergaji 50 juta sebulan bisa lebih miskin dari yang bergaji 10 juta? Jawabannya bukan soal angka, tapi soal behavioral finance..."`}
              data-testid="social-post-textarea"
              style={{
                width: '100%', minHeight: '140px',
                background: 'rgba(255,255,255,0.04)',
                border: `1px solid ${postText.length > 0 ? 'rgba(217,251,6,0.3)' : 'rgba(255,255,255,0.1)'}`,
                borderRadius: '0.75rem', padding: '0.875rem',
                color: '#EDEDED', fontSize: '0.9rem',
                fontFamily: 'Inter, sans-serif', resize: 'vertical',
                lineHeight: 1.6,
                transition: 'border-color 0.2s ease',
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.25rem' }}>
              <span style={{ fontSize: '0.7rem', color: postText.length < 20 && postText.length > 0 ? '#f87171' : '#71717A' }}>
                {postText.length < 20 && postText.length > 0 ? 'Minimal 20 karakter' : ''}
              </span>
              <span style={{ fontSize: '0.7rem', color: '#71717A' }}>
                {postText.length} karakter
              </span>
            </div>
          </div>

          {/* Source URL (optional) */}
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ fontSize: '0.8rem', color: '#A1A1AA', marginBottom: '0.375rem', display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
              <Link2 size={12} /> URL Postingan <span style={{ color: '#71717A', fontWeight: 400 }}>(opsional)</span>
            </label>
            <input
              value={sourceUrl}
              onChange={e => setSourceUrl(e.target.value)}
              placeholder={`https://www.${platform === 'twitter' ? 'x' : platform}.com/...`}
              data-testid="social-source-url"
              style={{
                width: '100%', background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '0.5rem', padding: '0.5rem 0.75rem',
                color: '#EDEDED', fontSize: '0.85rem',
              }}
            />
          </div>

          {/* Options row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.8rem', color: '#A1A1AA', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={autoPublish}
                onChange={e => setAutoPublish(e.target.checked)}
                style={{ accentColor: '#d9fb06' }}
                data-testid="social-auto-publish"
              />
              Langsung publish
            </label>
            <span style={{ fontSize: '0.75rem', color: '#71717A' }}>
              {autoPublish ? 'Artikel akan langsung dipublish setelah di-generate' : 'Artikel disimpan sebagai draft untuk di-review'}
            </span>
          </div>

          {/* Generate button */}
          <button
            onClick={handleGenerate}
            disabled={generating || postText.trim().length < 20}
            data-testid="social-generate-btn"
            style={{
              display: 'flex', alignItems: 'center', gap: '0.5rem',
              padding: '0.75rem 1.5rem', borderRadius: '0.625rem',
              border: 'none', cursor: postText.trim().length >= 20 ? 'pointer' : 'not-allowed',
              fontSize: '0.9rem', fontWeight: 600,
              background: postText.trim().length >= 20 ? '#d9fb06' : 'rgba(255,255,255,0.08)',
              color: postText.trim().length >= 20 ? '#0A0A0A' : '#71717A',
              transition: 'all 0.2s ease',
            }}
          >
            <Sparkles size={16} />
            Generate Artikel dengan AI
            <ArrowRight size={16} />
          </button>
        </div>
      )}

      {/* Step 2: Generating */}
      {step === 2 && (
        <div style={{ textAlign: 'center', padding: '2rem 0' }} data-testid="social-creator-step2">
          <Loader2 size={36} color="#d9fb06" style={{ animation: 'spin 1s linear infinite' }} />
          <p style={{ color: '#EDEDED', fontSize: '1rem', marginTop: '1rem', fontWeight: 500 }}>
            Membuat artikel "{selectedTemplate?.name}" dari {selectedPlatform?.label}...
          </p>
          <div style={{ margin: '1rem auto', maxWidth: '300px', height: '4px', background: 'rgba(255,255,255,0.1)', borderRadius: '2px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${genProgress}%`, background: '#d9fb06', borderRadius: '2px', transition: 'width 0.5s ease' }} />
          </div>
          <p style={{ color: '#71717A', fontSize: '0.8rem' }}>
            {genProgress < 30 ? 'Mengirim ke AI...' : genProgress < 70 ? 'AI sedang menulis artikel...' : 'Hampir selesai...'}
          </p>
          <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      {/* Step 3: Preview + Image Selection */}
      {step === 3 && generatedArticle && (
        <div data-testid="social-creator-step3">
          {/* Success banner */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: '0.75rem',
            padding: '0.75rem 1rem', borderRadius: '0.625rem',
            background: 'rgba(74,222,128,0.1)', border: '1px solid rgba(74,222,128,0.2)',
            marginBottom: '1rem',
          }}>
            <CheckCircle size={18} color="#4ade80" />
            <span style={{ color: '#4ade80', fontSize: '0.85rem', fontWeight: 500 }}>
              Artikel berhasil di-generate!
            </span>
            <span style={{
              marginLeft: 'auto', padding: '2px 8px', borderRadius: '12px', fontSize: '0.7rem', fontWeight: 600,
              background: generatedArticle.status === 'published' ? 'rgba(74,222,128,0.15)' : 'rgba(251,191,36,0.15)',
              color: generatedArticle.status === 'published' ? '#4ade80' : '#fbbf24',
            }}>
              {generatedArticle.status}
            </span>
          </div>

          {/* Article preview card */}
          <div style={{
            background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: '0.75rem', padding: '1.25rem', marginBottom: '1rem',
          }}>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
              {generatedArticle.featured_image && (
                <img
                  src={generatedArticle.featured_image?.startsWith('/api') ? `${BACKEND_URL}${generatedArticle.featured_image}` : generatedArticle.featured_image}
                  alt=""
                  style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '0.5rem', flexShrink: 0 }}
                />
              )}
              <div style={{ flex: 1 }}>
                <h4 style={{ color: '#EDEDED', fontFamily: "'Playfair Display', serif", fontSize: '1.1rem', marginBottom: '0.5rem', lineHeight: 1.3 }}>
                  {generatedArticle.title}
                </h4>
                <p style={{ color: '#A1A1AA', fontSize: '0.85rem', lineHeight: 1.5, marginBottom: '0.75rem' }}>
                  {generatedArticle.excerpt}
                </p>
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                  {generatedArticle.tags?.map((tag, i) => (
                    <span key={i} style={{
                      padding: '2px 8px', borderRadius: '8px', fontSize: '0.7rem',
                      background: 'rgba(217,251,6,0.1)', color: '#d9fb06',
                    }}>{tag}</span>
                  ))}
                  <span style={{
                    padding: '2px 8px', borderRadius: '8px', fontSize: '0.7rem',
                    background: `${selectedPlatform?.color}15`, color: selectedPlatform?.color,
                  }}>{selectedPlatform?.label}</span>
                  <span style={{
                    padding: '2px 8px', borderRadius: '8px', fontSize: '0.7rem',
                    background: `${selectedTemplate?.color}15`, color: selectedTemplate?.color,
                  }}>{selectedTemplate?.name}</span>
                </div>
              </div>
            </div>

            {/* Content preview (collapsed) */}
            <details style={{ marginTop: '1rem' }}>
              <summary style={{ color: '#71717A', fontSize: '0.8rem', cursor: 'pointer', userSelect: 'none' }}>
                <Eye size={12} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.25rem' }} />
                Preview konten artikel
              </summary>
              <div
                style={{
                  marginTop: '0.75rem', padding: '1rem',
                  background: 'rgba(255,255,255,0.02)', borderRadius: '0.5rem',
                  fontSize: '0.85rem', color: '#EDEDED', lineHeight: 1.7,
                  maxHeight: '300px', overflowY: 'auto',
                }}
                dangerouslySetInnerHTML={{ __html: generatedArticle.content }}
              />
            </details>
          </div>

          {/* Image Selection Section */}
          <div style={{
            background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)',
            borderRadius: '0.75rem', padding: '1.25rem', marginBottom: '1rem',
          }} data-testid="image-selection-section">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
              <h4 style={{ color: '#EDEDED', fontSize: '0.95rem', fontWeight: 600, margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <ImageIcon size={16} color="#d9fb06" /> Pilih Gambar Ilustrasi
              </h4>
              {imageOptions.length > 0 && !generatingImages && (
                <button
                  onClick={handleRegenerateImages}
                  data-testid="regenerate-images-btn"
                  style={{
                    display: 'flex', alignItems: 'center', gap: '0.25rem',
                    padding: '0.35rem 0.75rem', borderRadius: '0.375rem', border: 'none', cursor: 'pointer',
                    fontSize: '0.75rem', fontWeight: 500,
                    background: 'rgba(255,255,255,0.08)', color: '#A1A1AA',
                  }}
                >
                  <RefreshCw size={12} /> Generate Ulang
                </button>
              )}
            </div>

            {generatingImages && (
              <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                <Loader2 size={28} color="#d9fb06" style={{ animation: 'spin 1s linear infinite' }} />
                <p style={{ color: '#EDEDED', fontSize: '0.85rem', marginTop: '0.75rem' }}>
                  Membuat 3 pilihan gambar ilustrasi...
                </p>
                <div style={{ margin: '0.75rem auto', maxWidth: '250px', height: '3px', background: 'rgba(255,255,255,0.1)', borderRadius: '2px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${imageProgress}%`, background: '#d9fb06', borderRadius: '2px', transition: 'width 0.5s ease' }} />
                </div>
                <p style={{ color: '#71717A', fontSize: '0.75rem' }}>
                  {imageProgress < 30 ? 'Menganalisis artikel...' : imageProgress < 60 ? 'Generating gambar 1/3...' : imageProgress < 85 ? 'Generating gambar 2/3...' : 'Finishing gambar 3/3...'}
                </p>
              </div>
            )}

            {!generatingImages && imageOptions.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.75rem' }}>
                {imageOptions.map((img, idx) => (
                  <div
                    key={img.id}
                    onClick={() => handleSelectImage(idx)}
                    data-testid={`image-option-${idx}`}
                    style={{
                      position: 'relative', cursor: 'pointer', borderRadius: '0.625rem', overflow: 'hidden',
                      border: selectedImageIdx === idx ? '2px solid #d9fb06' : '2px solid rgba(255,255,255,0.08)',
                      transition: 'all 0.2s ease',
                      boxShadow: selectedImageIdx === idx ? '0 0 16px rgba(217,251,6,0.2)' : 'none',
                    }}
                  >
                    <img
                      src={img.url}
                      alt={`Opsi ${idx + 1}`}
                      style={{ width: '100%', aspectRatio: '16/10', objectFit: 'cover', display: 'block' }}
                    />
                    {selectedImageIdx === idx && (
                      <div style={{
                        position: 'absolute', top: '0.4rem', right: '0.4rem',
                        width: '22px', height: '22px', borderRadius: '50%',
                        background: '#d9fb06', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        <CheckCircle size={14} color="#0A0A0A" />
                      </div>
                    )}
                    <div style={{
                      position: 'absolute', bottom: 0, left: 0, right: 0,
                      padding: '0.35rem', textAlign: 'center',
                      background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                      color: '#A1A1AA', fontSize: '0.7rem',
                    }}>
                      Opsi {idx + 1}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {!generatingImages && imageOptions.length === 0 && (
              <div style={{ textAlign: 'center', padding: '1rem', color: '#71717A', fontSize: '0.85rem' }}>
                <ImageIcon size={24} style={{ margin: '0 auto 0.5rem', display: 'block', opacity: 0.4 }} />
                <p>Gambar belum tersedia. Klik tombol untuk generate.</p>
                <button
                  onClick={handleRegenerateImages}
                  data-testid="generate-images-btn"
                  style={{
                    marginTop: '0.5rem', display: 'inline-flex', alignItems: 'center', gap: '0.375rem',
                    padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer',
                    fontSize: '0.8rem', fontWeight: 500, background: '#d9fb06', color: '#0A0A0A',
                  }}
                >
                  <ImageIcon size={14} /> Generate Gambar
                </button>
              </div>
            )}
          </div>

          {/* Action buttons */}
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {generatedArticle.status === 'draft' && (
              <button
                onClick={handlePublishDraft}
                data-testid="social-publish-btn"
                style={{
                  display: 'flex', alignItems: 'center', gap: '0.375rem',
                  padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer',
                  fontSize: '0.85rem', fontWeight: 500,
                  background: 'rgba(74,222,128,0.15)', color: '#4ade80',
                }}
              >
                <CheckCircle size={14} /> Publish Sekarang
              </button>
            )}
            <button
              onClick={() => { if (generatedArticle) window.open(`/blog/${generatedArticle.id}`, '_blank'); }}
              data-testid="social-view-article-btn"
              style={{
                display: 'flex', alignItems: 'center', gap: '0.375rem',
                padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer',
                fontSize: '0.85rem', fontWeight: 500,
                background: 'rgba(255,255,255,0.08)', color: '#EDEDED',
              }}
            >
              <ExternalLink size={14} /> Lihat Artikel
            </button>
            <button
              onClick={handleReset}
              data-testid="social-create-another-btn"
              style={{
                display: 'flex', alignItems: 'center', gap: '0.375rem',
                padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer',
                fontSize: '0.85rem', fontWeight: 600, marginLeft: 'auto',
                background: '#d9fb06', color: '#0A0A0A',
              }}
            >
              <Sparkles size={14} /> Buat Artikel Lagi
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialArticleCreator;
